(function () {
	const initProductAccordion = () => {
		document.querySelectorAll(".about__accordion-toggle").forEach((toggle) => {
			if (toggle.dataset.accordionBound === "true") return;
			toggle.dataset.accordionBound = "true";

			toggle.addEventListener("click", function () {
				const description = this.nextElementSibling;
				if (!description || !description.classList.contains("about__accordion-description")) {
					return;
				}

				const isActive = this.classList.contains("active");
				this.classList.toggle("active", !isActive);
				description.style.display = isActive ? "none" : "block";
			});
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};



	const MIN_SCROLL_BEFORE_SHOW = 200;

	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup');
		const footer = document.querySelector('footer');
		const addToCartButtons = document.querySelector('.product-form__buttons');

		if (!stickyBar || !footer) return;
		if (stickyBar.dataset.revealPopupBound === "true") return;
		stickyBar.dataset.revealPopupBound = "true";

		let addToCartOutOfView = false;
		let footerInView = false;
		let frameRequested = false;

		const updateStickyBar = () => {
			const scrollY = window.scrollY;
			const hasScrolledEnough = scrollY >= MIN_SCROLL_BEFORE_SHOW;

			const showSticky =
				hasScrolledEnough &&
				!footerInView &&
				addToCartOutOfView;

			stickyBar.classList[showSticky ? 'add' : 'remove']('active');
		};

		const requestUpdate = () => {
			if (frameRequested) return;
			frameRequested = true;
			requestAnimationFrame(() => {
				frameRequested = false;
				updateStickyBar();
			});
		};

		if (addToCartButtons) {
			const addToCartObserver = new IntersectionObserver(([entry]) => {
				addToCartOutOfView = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
				requestUpdate();
			});
			addToCartObserver.observe(addToCartButtons);
		}

		const footerObserver = new IntersectionObserver(([entry]) => {
			footerInView = entry.isIntersecting;
			requestUpdate();
		});
		footerObserver.observe(footer);

		window.addEventListener('scroll', requestUpdate, { passive: true });
		requestUpdate();
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		//initZoomImage();
		revealPopup();
	});

	initProductAccordion();
	//initZoomImage();
	revealPopup();
})();

// === Free Shipping Threshold Pop-up Logic ===
(function () {
  function parseMoney(str) {
    if (!str) return 0;
    return parseFloat(str.replace(/[^\d.,]/g, '').replace('.', '').replace(',', '.')) || 0;
  }

  function updateShippingMessage(popupEl, threshold, price) {
    const paidMsg = popupEl.querySelector('.product-popup-modal__text');
    const freeMsg = popupEl.querySelector('.product-popup-modal__text_2');
	const labelsFirst = document.querySelectorAll('[data-label-first]');
	const labelsSecond = document.querySelectorAll('[data-label-second]');
    if (!paidMsg || !freeMsg) return;
    if (price <= threshold) {
      paidMsg.style.display = '';
      freeMsg.style.display = 'none';
	  labelsFirst.forEach(label => {
	  	label.style.display = '';
	  });
	  labelsSecond.forEach(label => {
	  	label.style.display = 'none';
	  });
    } else {
      paidMsg.style.display = 'none';
      freeMsg.style.display = '';
	  freeMsg.style.marginTop = '0';
	  labelsFirst.forEach(label => {
		label.style.display = 'none';
	  });
	  labelsSecond.forEach(label => {
		label.style.display = '';
	  });
    }
  }

  function getCurrentProductPrice() {
    const productPrice = document.querySelector('[data-product-price]');
	if (!productPrice) return;
	let price = Number(productPrice.dataset.productPrice)
	
    // Adjust for currency rate if available
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      const rate = parseFloat(window.Shopify.currency.rate);
      if (rate && !isNaN(rate) && rate !== 0) {
		price = price / 100 / rate;
      }
    }
    return price;
  }

  function updateAllPopups() {
    const popups = document.querySelectorAll('modal-dialog.main-product-popup[data-threshold-amount]');
    if (!popups.length) return;

    const price = getCurrentProductPrice();
    popups.forEach(popup => {
      const threshold = parseFloat(popup.getAttribute('data-threshold-amount'));
      if (!isNaN(threshold)) {
        updateShippingMessage(popup, threshold, price);
      }
    });
  }

  /**
   * Main logic to initialize threshold popups
   */
  function initShippingThresholdPopups() {
    const popups = document.querySelectorAll('modal-dialog.main-product-popup[data-threshold-amount]');
    if (!popups.length) return;

    if (document.documentElement.dataset.shippingThresholdBound !== "true") {
      document.documentElement.dataset.shippingThresholdBound = "true";
      document.addEventListener('product:variant-change', updateAllPopups);
    }

    // Fallback: observe price changes in the DOM
    const priceWrapper = document.querySelector('.price-wrapper');
    if (
      priceWrapper &&
      window.MutationObserver &&
      priceWrapper.dataset.shippingThresholdObserved !== "true"
    ) {
      priceWrapper.dataset.shippingThresholdObserved = "true";
      const observer = new MutationObserver(updateAllPopups);
      observer.observe(priceWrapper, { childList: true, subtree: true, characterData: true });
    }

    updateAllPopups();
  }

  document.addEventListener('DOMContentLoaded', initShippingThresholdPopups);
  document.addEventListener('shopify:section:load', initShippingThresholdPopups);
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					document
						.querySelectorAll(
							".product__popup .product-form__controls--dropdown"
						)
						.forEach((dropdown) => {
							if (dropdown.dataset.dropdownInit === "true") return;
							dropdown.dataset.dropdownInit = "true";

							const elListItem = Array.from(
								dropdown.querySelectorAll(".dropdown-select ul li")
							);
							const elItem = dropdown.querySelector(".dropdown-select ul");
							const selectedText = dropdown.querySelector(
								".dropdown-select .select-label"
							);
							if (!elItem || !selectedText) return;

							selectedText.addEventListener("click", (e) => {
								e.stopPropagation();
								elItem.classList.toggle("active");
							});

							elListItem.forEach((item) => {
								item.addEventListener("click", function () {
									const valueEl = this.querySelector(".select-labels__value");
									const input = this.querySelector("input");
									const valueOnly = valueEl
										? valueEl.textContent.trim()
										: (input?.value || "").trim();
									const dropdownFieldset = this.closest(
										".product-form__controls--dropdown"
									);
									const variantRadios = dropdownFieldset
										? dropdownFieldset.closest("variant-radios")
										: null;

									if (
										variantRadios &&
										typeof variantRadios.updateDropdownLabel === "function"
									) {
										variantRadios.updateDropdownLabel(
											dropdownFieldset,
											valueOnly
										);
									}

									elItem.classList.remove("active");
									if (document.activeElement instanceof HTMLElement) {
										document.activeElement.blur();
									}
								});
							});
						});
				};

				const initVariantDropdownFromUrl = () => {
					this.querySelectorAll("variant-radios").forEach((variantRadios) => {
						if (typeof variantRadios.initDropdownFromUrl === "function") {
							variantRadios.initDropdownFromUrl();
						}
					});
				};

				selectDropDown();
				initVariantDropdownFromUrl();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinject external scripts only. Re-executing inline scripts can redeclare
		// globals on product pages (e.g. shopify_collection_ids) and throw syntax errors.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const scriptType = (oldScriptTag.getAttribute("type") || "").trim();
			const isDataScript =
				scriptType === "application/json" ||
				scriptType === "application/ld+json";

			// Keep non-executable data scripts in place (variant JSON, structured data).
			if (isDataScript) {
				return;
			}

			const source = oldScriptTag.getAttribute("src");
			if (!source) {
				oldScriptTag.remove();
				return;
			}

			if (document.querySelector(`script[src="${source}"]`)) {
				oldScriptTag.remove();
				return;
			}

			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    	const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    	const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const deliveryEstimate = this.productElement.querySelector("delivery-estimate");
		if (deliveryEstimate) deliveryEstimate.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const usp = this.productElement.querySelectorAll(".usp-wrapper");
		usp.forEach((usp) => {
			usp.remove();
		});

		const accordion = this.productElement.querySelectorAll(".custom-accordion__wrapper");
		accordion.forEach((accordion) => {
			accordion.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		this.querySelectorAll(".js-show-more").forEach((button) => {
			if (button.dataset.showMoreBound === "true") return;
			button.dataset.showMoreBound = "true";

			button.addEventListener("click", function (e) {
				e.preventDefault();
				this.parentElement
					?.querySelectorAll("input.hidden, label.hidden")
					.forEach((el) => el.classList.remove("hidden"));
				this.remove();
			});
		});
	}
}

customElements.define("floated-form", FloatedForm);

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;
					const recommendations = html.querySelector("product-recommendations");
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}

					/* Color swatches */
					const generateSrcset = (image, widths = []) => {
						const imageUrl = new URL(image["src"]);
						return widths
							.filter((width) => width <= image["width"])
							.map((width) => {
								imageUrl.searchParams.set("width", width.toString());
								return `${imageUrl.href} ${width}w`;
							})
							.join(", ");
					};

					const createImageElement = (image, classes, sizes, productTitle) => {
						const previewImage = image["preview_image"];
						const newImage = new Image(
							previewImage["width"],
							previewImage["height"]
						);
						newImage.className = classes;
						newImage.alt = image["alt"] || productTitle;
						newImage.sizes = sizes;
						newImage.src = previewImage["src"];
						newImage.srcset = generateSrcset(
							previewImage,
							[165, 360, 533, 720, 940, 1066]
						);
						newImage.loading = "lazy";
						return newImage;
					};

					const checkSwatches = () => {
						this
							.querySelectorAll(".js-color-swatches-wrapper")
							.forEach((wrapper) => {
								wrapper
									.querySelectorAll(".js-color-swatches input")
									.forEach((input) => {
										if (input.dataset.swatchBound === "true") return;
										input.dataset.swatchBound = "true";

										input.addEventListener("click", (event) => {
											const primaryImage =
												wrapper.querySelector(".media--first");
											const secondaryImage =
												wrapper.querySelector(".media--second");
											const handleProduct = wrapper.dataset.product;

											if (event.currentTarget.checked && primaryImage) {
												wrapper
													.querySelector(".js-color-swatches-link")
													.setAttribute(
														"href",
														event.currentTarget.dataset.variantLink
													);
												if (
													wrapper.querySelector(
														'.card__add-to-cart button[name="add"]'
													)
												) {
													wrapper
														.querySelector(
															'.card__add-to-cart button[name="add"]'
														)
														.setAttribute("aria-disabled", false);
													if (
														wrapper.querySelector(
															'.card__add-to-cart button[name="add"] > span'
														)
													) {
														wrapper
															.querySelector(
																'.card__add-to-cart button[name="add"] > span'
															)
															.classList.remove("hidden");
														wrapper
															.querySelector(
																'.card__add-to-cart button[name="add"] .sold-out-message'
															)
															.classList.add("hidden");
													}
													wrapper.querySelector(
														'.card__add-to-cart input[name="id"]'
													).value = event.currentTarget.dataset.variantId;
												}
												const currentColor = event.currentTarget.value;

												fetch(
													window.Shopify.routes.root +
														`products/${handleProduct}.js`
												)
													.then((response) => {
														if (!response.ok) {
															throw new Error(
																`Failed to fetch product JSON: ${response.status}`
															);
														}
														return response.json();
													})
													.then((product) => {
														const variant = product.variants.filter(
															(item) =>
																item.featured_media != null &&
																item.options.includes(currentColor)
														)[0];

														if (variant) {
															const newPrimaryImage = createImageElement(
																variant["featured_media"],
																primaryImage.className,
																primaryImage.sizes,
																product.title
															);

															if (newPrimaryImage.src !== primaryImage.src) {
																let flag = false;
																if (secondaryImage) {
																	const secondaryImagePathname = new URL(
																		secondaryImage.src
																	).pathname;
																	const newPrimaryImagePathname = new URL(
																		newPrimaryImage.src
																	).pathname;

																	if (
																		secondaryImagePathname ==
																		newPrimaryImagePathname
																	) {
																		primaryImage.remove();
																		secondaryImage.classList.remove(
																			"media--second"
																		);
																		secondaryImage.classList.add(
																			"media--first"
																		);
																		flag = true;
																	}
																}
																if (flag == false) {
																	primaryImage.animate(
																		{ opacity: [1, 0] },
																		{
																			duration: 200,
																			easing: "ease-in",
																			fill: "forwards",
																		}
																	).finished;
																	setTimeout(function () {
																		primaryImage.replaceWith(newPrimaryImage);
																		newPrimaryImage.animate(
																			{ opacity: [0, 1] },
																			{ duration: 200, easing: "ease-in" }
																		);
																		if (secondaryImage) {
																			secondaryImage.remove();
																		}
																	}, 200);
																}
															}
														}
													})
													.catch((error) => {
														console.error(error);
													});
											}
										});
									});
							});
					};

					checkSwatches();

					const calcTop = (section) => {
						const imageWrapper = section.querySelectorAll(".card__inner");
						let top = 0;

						if (imageWrapper) {
							top = imageWrapper[0]?.offsetHeight / 2;
						} else {
							top = 50;
						}

						return top;
					};

					const initSlider = () => {
						if (typeof window.initProductSlideshows === 'function') {
							window.initProductSlideshows(this);
						}
					};

					const initSection = () => {
						const section = this;

						const sectionResizeObserver = new ResizeObserver((entries) => {
							const [entry] = entries;
							let top = calcTop(section);
							if (section.querySelector(".product-recommendations__slider-nav"))
								section.querySelector(
									".product-recommendations__slider-nav"
								).style.top = top + "px";
						});

						sectionResizeObserver.observe(section);

						initSlider();
					};

					const initProductSlider = () => {
						if (typeof window.initProductCardSliders === "function") {
							window.initProductCardSliders(this);
							return;
						}

						const sliders = this.querySelectorAll(".product-card-js");

						sliders.forEach((slider) => {
							if (slider.classList.contains("swiper-initialized") || slider.swiper) return;

							const cardRoot = slider.closest(".card");
							const paginationEl =
								cardRoot?.querySelector(".product-pagination .swiper-pagination") ||
								slider.querySelector(".product-pagination .swiper-pagination");
							const nextEl =
								cardRoot?.querySelector(".product-button-group .swiper-button-next") ||
								slider.querySelector(".product-button-group .swiper-button-next");
							const prevEl =
								cardRoot?.querySelector(".product-button-group .swiper-button-prev") ||
								slider.querySelector(".product-button-group .swiper-button-prev");

							new Swiper(slider, {
								pagination: paginationEl
									? {
											el: paginationEl,
											clickable: true,
									  }
									: undefined,
								navigation:
									nextEl && prevEl
										? {
												nextEl,
												prevEl,
										  }
										: undefined,
							});
						});
					};

					initProductSlider();

					initSection();

					// Convert prices to euros after recommendations content is loaded
					if (typeof window.convertPricesToEuros === 'function') {
						window.convertPricesToEuros();
					}

					document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: "0px 0px 200px 0px",
		}).observe(this);
	}
}

customElements.define("product-recommendations", ProductRecommendations);

class SimilarProducts extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);
			this.loadSimilarProducts();
		};

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: "0px 0px 200px 0px",
		}).observe(this);
	}

	loadSimilarProducts() {
		const cloudsearchUrl = this.dataset.cloudsearchUrl;
		const sectionId = this.dataset.sectionId;
		const searchUrl = this.dataset.url;
		const lang = this.dataset.lang || "en";
		const productsLimit = parseInt(this.dataset.productsLimit || "12", 10);
		const currentProductId = this.dataset.currentProductId || "";
		const currentProductHandle = (this.dataset.currentProductHandle || "").trim();
		const collectionRootHandle = this.dataset.collectionRootHandle || "";
		const gender = this.dataset.collectionGender || "";
		const categoryLevel2 =
			this.dataset.categoryLevel2 ||
			this.getAttribute("data-category-level-2") ||
			"";
		const categoryLevel3 =
			this.dataset.categoryLevel3 ||
			this.getAttribute("data-category-level-3") ||
			"";
		const color = this.dataset.color || this.getAttribute("data-color") || "";
		const designer =
			this.dataset.designer || this.getAttribute("data-designer") || "";

		if (!cloudsearchUrl || !sectionId || !searchUrl) return;
		if (!collectionRootHandle || !gender) return;
		if (!productsLimit || productsLimit <= 0) return;

		const VIEW_MORE_MIN_PRODUCTS = 48;
		const levels = ["strict", "noDesigner", "noColor", "medium", "broad"];

		const updateViewMoreHref = (level, options = {}) => {
			const { hasDesignerCategoryResults = true } = options;
			const viewMoreBtn = this.querySelector(".js-similar-view-more");
			if (!viewMoreBtn) return;
			const genderSuffix =
				gender === "female" ? "woman" : gender === "male" ? "man" : "";
			const handleize = (s) =>
				(s || "")
					.toLowerCase()
					.replace(/[^a-z0-9]+/g, "-")
					.replace(/^-|-$/g, "");
			const pathSegment = [
				collectionRootHandle,
				// In designer mode, only broaden beyond level-2 when level-2 has no hits.
				designer && !hasDesignerCategoryResults ? "" : handleize(categoryLevel2),
				genderSuffix,
			]
				.filter(Boolean)
				.join("-");
			const params = new URLSearchParams();
			// In designer mode, "View more" should show all pieces by this designer.
			// Otherwise keep the style/color constraints.
			if (designer) {
				params.set("filter_designer", designer);
			} else {
				if (categoryLevel3) params.set("filter_style", categoryLevel3);
				if (color) params.set("filter_custom.color", color);
			}
			const query = params.toString();
			viewMoreBtn.setAttribute(
				"href",
				pathSegment ? `/a/search/${pathSegment}${query ? `?${query}` : ""}` : "#"
			);
		};
		updateViewMoreHref("strict");

		console.log("[SimilarProducts] config", {
			cloudsearchUrl,
			sectionId,
			searchUrl,
			lang,
			productsLimit,
			currentProductId,
			collectionRootHandle,
			gender,
			categoryLevel2,
			categoryLevel3,
			color,
			designer,
		});

		let genderSuffix = "";
		if (gender === "female") {
			genderSuffix = "woman";
		} else if (gender === "male") {
			genderSuffix = "man";
		}

		if (!genderSuffix) return;

		const collectionHandle = `${collectionRootHandle}-${genderSuffix}`;

		const baseBody = {
			q: null,
			lang,
			facet: true,
			conditions: {
				collection_handle: [collectionHandle],
			},
			filters: {
				availability: { in_stock: true },
			},
			offset: 0,
			limits: {
				products: VIEW_MORE_MIN_PRODUCTS,
				categories: 0,
				pages: 0,
				manufacturers: 0,
			},
			idsOnly: false,
			sort_by: "relevance",
		};

		const strictFilters = { ...baseBody.filters };
		if (categoryLevel2) strictFilters.category = [categoryLevel2];
		if (categoryLevel3) strictFilters.style = [categoryLevel3];
		// Keep color key aligned with storefront URL filter_custom.color.
		if (color) strictFilters["custom.color"] = [color];
		if (designer) strictFilters.designer = [designer];

		const noDesignerFilters = { ...baseBody.filters };
		if (categoryLevel2) noDesignerFilters.category = [categoryLevel2];
		if (categoryLevel3) noDesignerFilters.style = [categoryLevel3];
		if (color) noDesignerFilters["custom.color"] = [color];

		const noColorFilters = { ...baseBody.filters };
		if (categoryLevel2) noColorFilters.category = [categoryLevel2];
		if (categoryLevel3) noColorFilters.style = [categoryLevel3];
		if (designer) noColorFilters.designer = [designer];

		const designerBroadFilters = { ...baseBody.filters };
		if (designer) designerBroadFilters.designer = [designer];

		const mediumFilters = { ...baseBody.filters };
		if (categoryLevel2) mediumFilters.category = [categoryLevel2];
		if (categoryLevel3) mediumFilters.style = [categoryLevel3];

		const requestConfigs = designer
			? [
					{ body: { ...baseBody, filters: strictFilters }, level: "strict" },
					{ body: { ...baseBody, filters: noColorFilters }, level: "noColor" },
					{
						body: { ...baseBody, filters: designerBroadFilters },
						level: "designerBroad",
					},
					{ body: { ...baseBody, filters: noDesignerFilters }, level: "noDesigner" },
					{ body: { ...baseBody, filters: mediumFilters }, level: "medium" },
					{ body: { ...baseBody }, level: "broad" },
				]
			: [
					{ body: { ...baseBody, filters: strictFilters }, level: "strict" },
					{ body: { ...baseBody, filters: noDesignerFilters }, level: "noDesigner" },
					{ body: { ...baseBody, filters: noColorFilters }, level: "noColor" },
					{ body: { ...baseBody, filters: mediumFilters }, level: "medium" },
					{ body: { ...baseBody }, level: "broad" },
				];

		const fetchRequests = requestConfigs.map((config) =>
			fetch(cloudsearchUrl, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(config.body),
			})
				.then((response) => {
					if (!response.ok) return null;
					return response.json();
				})
				.catch(() => null),
		);

		Promise.allSettled(fetchRequests)
			.then((results) => {
				const seenHandles = new Set();
				const finalHandles = [];
				const max = productsLimit;
				const currentIdStr = currentProductId ? String(currentProductId) : "";

				const debugLevelCounts = {};
				requestConfigs.forEach((config, i) => {
					const count =
						results[i].status === "fulfilled" && results[i].value?.products
							? results[i].value.products.length
							: 0;
					debugLevelCounts[config.level] = count;
				});

				const usedLevels = new Set();
				const addFromResponse = (response, level) => {
					if (!response || !response.products) return;
					const beforeLen = finalHandles.length;
					for (const product of response.products) {
						const idStr = product.id ? String(product.id) : "";
						if (idStr === currentIdStr) continue;
						const handle = (product.url || "").match(/^\/products\/([^/?#]+)/)?.[1];
						if (!handle || seenHandles.has(handle)) continue;
						seenHandles.add(handle);
						finalHandles.push(handle);
						if (finalHandles.length >= max) return;
					}
					if (finalHandles.length > beforeLen) {
						usedLevels.add(level);
					}
				};

				requestConfigs.forEach((config, i) => {
					if (finalHandles.length >= max) return;
					if (results[i].status !== "fulfilled") return;
					addFromResponse(results[i].value, config.level);
				});

				const handles = finalHandles.filter(
					(h) => h && h !== currentProductHandle
				);
				const usedLevelsOrdered = requestConfigs
					.map((c) => c.level)
					.filter((level) => usedLevels.has(level));
				const viewMoreLevel = usedLevelsOrdered[0] || "broad";
				const hasDesignerCategoryResults =
					(designer ? debugLevelCounts.strict || 0 : 0) +
						(designer ? debugLevelCounts.noColor || 0 : 0) >
					0;

				console.log("[SimilarProducts] levelCounts", debugLevelCounts);
				console.log("[SimilarProducts] usedLevels", usedLevelsOrdered);
				console.log("[SimilarProducts] chosen viewMoreLevel", viewMoreLevel);
				console.log(
					"[SimilarProducts] hasDesignerCategoryResults",
					hasDesignerCategoryResults
				);
				console.log("[SimilarProducts] finalHandles", handles);

				if (handles.length === 0) return null;

				const queryParam = handles.join(",");
				const url = `${searchUrl}${encodeURIComponent(queryParam)}`;

				console.log("[SimilarProducts] Section render URL (handles)", url);

				return fetch(url)
					.then((response) => {
						if (!response.ok) return null;
						return response.text();
					})
					.then((text) => {
						if (!text) return;
						const html = document.createElement("div");
						html.innerHTML = text;
						const section = html.querySelector(
							`#shopify-section-${sectionId}`
						);
						if (!section) return;
						const similar = section.querySelector("similar-products");
						if (similar && similar.innerHTML.trim().length) {
							// The fetched render has no product context, so keep the
							// server-rendered heading (and its brand collection link).
							const originalHeading = this.querySelector(
								".section-heading__heading"
							);
							this.innerHTML = similar.innerHTML;
							const fetchedHeading = this.querySelector(
								".section-heading__heading"
							);
							if (originalHeading && fetchedHeading) {
								fetchedHeading.replaceWith(originalHeading);
							}

							// Force product links to absolute URLs so they are not affected by
							// other JS (e.g. base tag, gender/redirect logic) and navigate correctly.
							const origin = window.location.origin;
							this.querySelectorAll('a[href*="/products/"]').forEach(
								(a) => {
									const href = (a.getAttribute("href") || "").trim();
									const path = href.split("?")[0].split("#")[0];
									if (
										path.startsWith("/") &&
										path.includes("/products/")
									) {
										a.setAttribute("href", origin + path);
									}
								}
							);

							const headingSpan = this.querySelector(
								".js-similar-category"
							);
							const categoryText =
								(this.dataset.categoryLevel2 ||
									this.getAttribute("data-category-level-2") ||
									"") + "";
							// Match Liquid: brand (as stored) when data-designer is set
							// (show_designer), else category_level_2 lowercased.
							if (headingSpan) {
								if (designer) {
									headingSpan.textContent = designer;
								} else if (categoryText) {
									headingSpan.textContent = categoryText.toLowerCase();
								}
							}

							updateViewMoreHref(viewMoreLevel, {
								hasDesignerCategoryResults,
							});

							document.dispatchEvent(
								new CustomEvent("shopify:section:load")
							);

							document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
						}
					})
					.catch(() => null);
			})
			.catch(() => {});
	}
}

customElements.define("similar-products", SimilarProducts);

class RecentlyViewedProducts extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			if (typeof Storage === "undefined") return;

			let viewedProducts = localStorage.getItem("viewedProducts");
			viewedProducts = viewedProducts ? JSON.parse(viewedProducts) : [];

			if (viewedProducts.length === 0) return;

			const currentProductHandle = this.dataset.currentProductHandle;
			const filteredProducts = currentProductHandle
				? viewedProducts.filter((handle) => handle !== currentProductHandle)
				: viewedProducts;

			if (filteredProducts.length === 0) return;

			const productHandles = filteredProducts.join(",");
			const url = `${this.dataset.url}${encodeURIComponent(productHandles)}`;

			fetch(url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;
					const sectionId = this.dataset.sectionId;
					const section = html.querySelector(`#shopify-section-${sectionId}`);
					if (section) {
						const recentlyViewed = section.querySelector("recently-viewed-products");
						if (recentlyViewed && recentlyViewed.innerHTML.trim().length) {
							this.innerHTML = recentlyViewed.innerHTML;
							document.dispatchEvent(new CustomEvent("shopify:section:load"));
							document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
						}
					}
				})
				.catch((error) => {
					console.error("Error fetching recently viewed products:", error);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: "0px 0px 200px 0px",
		}).observe(this);
	}
}

customElements.define("recently-viewed-products", RecentlyViewedProducts);